import axios from 'axios';
import qs from 'qs';
import { api } from '../../app/conf';

export const refreshTokenService = (refreshToken) => axios({
    method: 'post',
    url: `${api}/auth/refresh`,
    data: qs.stringify({ token: refreshToken })
});
